var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import clsx from "clsx";
import { forwardRef } from "react";
import { useStyles } from "./ui_box.css";
export const UiBox = forwardRef((_a, ref) => {
    var { isCustomScrollbar, className } = _a, props = __rest(_a, ["isCustomScrollbar", "className"]);
    const classes = useStyles();
    return (_jsx(Box, Object.assign({ ref: ref, className: clsx(className, isCustomScrollbar && classes.customScrollBar) }, props)));
});
//# sourceMappingURL=ui_box.js.map